// IELTS Mock 8 — Listening (IELTS Fever Listening Practice Test 34)
// Same shape as IELTS_DATA_LISTENING in ../IeltsListening.js (4 parts, 40 questions,
// one audio track that plays once straight through).
// Adapted to this page's question types:
//   - Q2 (answer key A, C and D) is a one-pick choice group that accepts any of the three.
//   - T/F/N and A/I/? statements are MCQs; "?" is shown as "N" because the grader
//     compares letters only.
//   - Q36 ("name any two") asks for one country so a single answer can be marked.
// No `audioStart` timings yet, so the page doesn't auto-scroll between Parts.

const AUDIO_SRC = "/audio/ielts_listening8.mp3";

const TFN = ["T. True", "F. False", "N. Not given"];
const AIN = ["A. Accurate", "I. Inaccurate", "N. Insufficient information (?)"];

const IELTS_MOCK8_LISTENING = {
  title: "IELTS Listening Mock 8",
  sections: [
    {
      id: "s1",
      title: "Section 1: A Job at the Summer Festival Centre / A Mail-order Complaint",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Question 1: Choose the correct letter, A, B, C or D.",
          image: null,
          questions: [
            {
              id: "q1",
              text: "Why has Steve applied for this job?",
              type: "mcq",
              options: [
                "A. Because he likes sports.",
                "B. Because he likes music.",
                "C. Because he needs money.",
                "D. Because he enjoys meeting with people.",
              ],
              answer: "D",
            },
          ],
        },
        {
          instruction: "Question 2: Choose ONE letter, A–D.",
          chooseTwo: true,
          question: "Which skill is needed to work in the Summer Festival Centre?",
          options: [
            "A. Can cook.",
            "B. Can speak at least two languages.",
            "C. Can play some musical instruments.",
            "D. Can drive.",
          ],
          answer: ["A", "C", "D"],
          questions: [{ id: "q2" }],
        },
        {
          instruction: "Question 3: Choose the correct letter, A, B, C or D.",
          image: null,
          questions: [
            {
              id: "q3",
              text: "How much would he expect to be paid for four weeks?",
              type: "mcq",
              options: [
                "A. One hundred pounds.",
                "B. Two hundred pounds.",
                "C. Three hundred pounds.",
                "D. Four hundred pounds.",
              ],
              answer: "D",
            },
          ],
        },
        {
          instruction: "Questions 4–7: Complete the form below.",
          heading:
            "City Mail-order Company — Caller: Steve Brown · Address: 31, Green Road, London NW1 4ER · Reference No.: AD 58412 · Model: Sports · Way of paying: by cheque",
          image: null,
          questions: [
            { id: "q4", text: "Caller's address (area/centre): ______", type: "fill_blank", answer: ["Euston Centre", "Euston Center", "the Euston Centre"] },
            {
              id: "q5",
              text: "Order: ______",
              type: "fill_blank",
              answer: ["a 22-inch frame bicycle", "22-inch frame bicycle", "a 22 inch frame bicycle", "22 inch frame bicycle", "22-inch bicycle", "a 22-inch bicycle", "22 inch bicycle", "22-inch frame bike", "22 inch frame bike"],
            },
            { id: "q6", text: "Price: £______", type: "fill_blank", answer: ["249.50", "£249.50", "249.5", "249.50 pounds"] },
            { id: "q7", text: "Time of delivering: ______", type: "fill_blank", answer: ["within 3 weeks", "within three weeks", "3 weeks", "three weeks"] },
          ],
        },
        {
          instruction:
            "Questions 8–10: Choose T if the statement is true, F if the statement is false or N if there is no information given.",
          image: null,
          questions: [
            { id: "q8", text: "Mr. Brown got the bicycle two weeks ago.", type: "mcq", options: TFN, answer: "N" },
            { id: "q9", text: "Mr. Brown paid by cheque.", type: "mcq", options: TFN, answer: "F" },
            { id: "q10", text: "Mr. Brown will check what has happened.", type: "mcq", options: TFN, answer: "T" },
          ],
        },
      ],
    },

    {
      id: "s2",
      title: "Section 2: Students Helping the Community",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 11–14: Complete the summary below. Write NO MORE THAN TWO WORDS for each answer.",
          heading: "This is a nationwide scheme.",
          image: null,
          questions: [
            { id: "q11", text: "The National Union of Students will run a National ______ next month.", type: "fill_blank", answer: ["Community Week"] },
            { id: "q12", text: "Every student should ______ some time to help the community.", type: "fill_blank", answer: ["give up"] },
            { id: "q13", text: "Aim 1: to show the public that students are ______ members of society.", type: "fill_blank", answer: ["responsible"] },
            { id: "q14", text: "Aim 2: to show students can give their ______ help to their community.", type: "fill_blank", answer: ["practical"] },
          ],
        },
        {
          instruction: "Questions 15–17: Complete the form below.",
          image: null,
          questions: [
            { id: "q15", text: "The old man's name: ______", type: "fill_blank", answer: ["Mr. Tyler", "Mr Tyler", "Tyler"] },
            { id: "q16", text: "Address: ______", type: "fill_blank", answer: ["8 Milkman Street", "8 Milkman St", "8 Milkman St."] },
            { id: "q17", text: "Student's job: ______", type: "fill_blank", answer: ["paint the kitchen", "painting the kitchen", "paint kitchen", "to paint the kitchen"] },
          ],
        },
        {
          instruction:
            "Questions 18–20: Choose A for an accurate statement, I for an inaccurate statement, or N if there is insufficient information (?).",
          image: null,
          questions: [
            { id: "q18", text: "The old lady never went out to work.", type: "mcq", options: AIN, answer: "I" },
            { id: "q19", text: "The old lady's husband once served in the Army.", type: "mcq", options: AIN, answer: "A" },
            { id: "q20", text: "The girl student also liked the book very much.", type: "mcq", options: AIN, answer: "N" },
          ],
        },
      ],
    },

    {
      id: "s3",
      title: "Section 3: Talks about the Koala and the Giraffe",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 21–29: Complete the notes below.",
          heading: "The koala — In Queensland: reddish/tawny",
          image: null,
          questions: [
            { id: "q21", text: "Koalas in New South Wales are (colour) ______", type: "fill_blank", answer: ["greyish", "grayish", "grey", "gray"] },
            { id: "q22", text: "Koalas in Victoria are (colour) ______", type: "fill_blank", answer: ["brownish", "brown"] },
            { id: "q23", text: "Koalas like to live ______", type: "fill_blank", answer: ["alone", "on their own", "by themselves"] },
            { id: "q24", text: "The mating season for koalas is ______", type: "fill_blank", answer: ["from spring to early summer", "spring to early summer"] },
            {
              id: "q25",
              text: "A baby koala is ______",
              type: "fill_blank",
              answer: ["very tiny", "tiny", "furless", "born without fur", "without fur", "0.5 of a gram", "half a gram"],
            },
            { id: "q26", text: "A baby koala stays in the mother's pouch ______", type: "fill_blank", answer: ["for six months", "for 6 months", "six months", "6 months"] },
            {
              id: "q27",
              text: "Koalas survive on a diet of leaves of 13 species of gum trees and don't ______",
              type: "fill_blank",
              answer: ["drink any water", "drink water", "drink"],
            },
            { id: "q28", text: "Koalas in zoos live longer than the ones ______", type: "fill_blank", answer: ["in the wild"] },
            { id: "q29", text: "Adult female koalas are ______", type: "fill_blank", answer: ["smaller", "about 60cm", "about 60 cm", "60cm", "60 cm", "about 60 centimetres"] },
          ],
        },
        {
          instruction: "Questions 30–34: Complete the form below.",
          heading: "The giraffe — Head: with 2 short horns",
          image: null,
          questions: [
            { id: "q30", text: "Height of an adult male giraffe: ______", type: "fill_blank", answer: ["about 6 metres tall", "about 6 metres", "6 metres tall", "6 metres", "6 meters", "about 6 meters", "6m", "about six metres", "six metres"] },
            { id: "q31", text: "Height of a baby giraffe: ______", type: "fill_blank", answer: ["2 metres tall", "2 metres", "2 meters", "two metres", "2m", "about 2 metres"] },
            { id: "q32", text: "Eyes: ______", type: "fill_blank", answer: ["big, brown, with thick lashes", "big brown with thick lashes", "big and brown with thick lashes", "big brown eyes with thick lashes", "big, brown"] },
            { id: "q33", text: "Diet: ______", type: "fill_blank", answer: ["leaves", "leaves without drinking water", "leaves, without drinking water"] },
            { id: "q34", text: "Way of self-protecting: gallop away or ______", type: "fill_blank", answer: ["fight with legs", "fight with their legs", "fight with its legs", "fight"] },
          ],
        },
      ],
    },

    {
      id: "s4",
      title: "Section 4: Paper and Its Use",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 35–40: Answer the questions below. Write NO MORE THAN THREE WORDS for each answer.",
          image: null,
          questions: [
            { id: "q35", text: "How much paper does a person in some countries use now in a year? ______", type: "fill_blank", answer: ["50 kilos", "50 kg", "50 kilograms", "fifty kilos", "50 kilo"] },
            {
              id: "q36",
              text: "Name ONE of the countries that use more paper than others. ______",
              type: "fill_blank",
              answer: ["United States", "the United States", "USA", "the USA", "US", "America", "Britain", "Great Britain", "Germany", "Sweden", "Japan"],
            },
            { id: "q37", text: "What was Chinese paper made from? ______", type: "fill_blank", answer: ["certain plants", "plants"] },
            {
              id: "q38",
              text: "What was parchment made from? ______",
              type: "fill_blank",
              answer: ["skin of animals", "animal skin", "animal skins", "young animals' skin", "young animal skin", "skin", "skins"],
            },
            { id: "q39", text: "Who found out that paper could be made from trees? ______", type: "fill_blank", answer: ["a German", "German", "a German man"] },
            { id: "q40", text: "Which country makes the best paper? ______", type: "fill_blank", answer: ["Finland"] },
          ],
        },
      ],
    },
  ],
};

export default IELTS_MOCK8_LISTENING;
